import React, {useEffect, useState} from 'react'
import { useMediaQuery } from "react-responsive";

import Login from './views/Login'
import Scan from "./views/Scan";
import CodeBlank from "./views/CodeBlank";

import {getAuthProvider} from './providers/Auth'
import {getBlanksProvider} from './providers/Blanks'

import Sheet from "@mui/joy/Sheet";
import {Box, CircularProgress, Divider, List, ListItem, Stack} from "@mui/joy";
import Button from "@mui/joy/Button";
import Typography from "@mui/joy/Typography";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotate } from "@fortawesome/free-solid-svg-icons";

import Navbar from "./views/Navbar";

function App() {
    const isMobile = useMediaQuery({ query: "(max-width: 600px)" });

    const [accessToken, setAccessToken] = useState(localStorage.getItem('accessToken') || null);
    const [isAuthorized, setAuthorized] = useState(false);
    const [isScanning, setScanning] = useState(false);
    const [isLoading, setLoading] = useState(true);
    const [code, setCode] = useState(null);

    const authProvider = getAuthProvider("https://auth.prod.kazpost.org");
    const blankProvider = getBlanksProvider({
        "blank_info": "https://gateway.prod.kazpost.org/superapp-backend/api/v1",
        "blank_pdf": "https://gateway.prod.kazpost.org/mail-app/public",
    });

    useEffect(() => {
        setLoading(true);
        authProvider.validate(accessToken).then(() => {
            setAuthorized(true);
            setLoading(false);
        }).catch(() => {
            setAuthorized(false);
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
            setLoading(false);
        });
    }, []);

    const handleLogin = () => {
        setAuthorized(true);
    };

    const handleScan = (code) => {
        setScanning(false);
        setCode(code);
    };

    if (isLoading) {
        return <CircularProgress/>
    }

    if (!isAuthorized) {
        return <Login authProvider={authProvider} onLogin={handleLogin}/>
    }

    if (isScanning) {
        return <Scan onScan={handleScan}/>
    }

    return (
        <>
            <Navbar/>
            <Sheet sx={{
                width: isMobile ? '80%' : '70%',
                mx: 'auto',
                mt: isMobile ? '0' : '3em',
                mb: '3em',
                py: 3,
                px: 3,
                borderRadius: isMobile ? '0' : 'lg',
                backgroundColor: '#FFFFFF',
                borderColor: '#E5E5E5',
            }} variant="outlined">
                <Stack direction={isMobile ? "column" : "row"} spacing={2} divider={<Divider orientation="vertical"/>}>
                    <Box sx={{width: isMobile ? '100%' : '60%'}}>
                        <Typography level="h3">Отсканируйте рукописный код на посылке</Typography>
                        <Button
                            onClick={() => setScanning(true)}
                            variant={code ? "soft" : "solid"}
                            sx={{mt: 2, p: 1.5, borderRadius: 'lg'}}
                            startDecorator={code ? <FontAwesomeIcon icon={faRotate}/> : null}
                        >
                            {code ? "Сканировать заново" : "Начать сканировать"}
                        </Button>
                        <br/>
                        <br/>
                        <CodeBlank
                            blankProvider={blankProvider}
                            code={code}
                            setCode={setCode}
                            sx={{mt: 5}}
                        />
                    </Box>
                    <Box sx={{width: isMobile ? '100%' : '40%'}}>
                        <Typography level="h4">Инструкции</Typography>
                        <List marker="decimal" sx={{"--ListItem-paddingY": "0", "--List-gap": "10px"}}>
                            <ListItem>Нажмите кнопку "Начать сканировать" и разрешите доступ к камере вашего
                                устройства.</ListItem>
                            <ListItem>Наведите камеру на рукописный код, расположенный на посылке клиента, и дождитесь
                                автоматического сканирования.</ListItem>
                            <ListItem>После успешного сканирования, система сгенерирует почтовый бланк в формате PDF с
                                ШПИ номером.</ListItem>
                            <ListItem>Распечатайте бланк и убедитесь, что он четко отображается. Свертесь с клиентом в
                                правильности адреса.</ListItem>
                            <ListItem>Наклейте почтовый бланк на посылку на место рукописного кода.</ListItem>
                            <ListItem>Взвесьте посылку и примите оплату от клиента.</ListItem>
                        </List>
                        <Typography level="h4">Для чего это нужно?</Typography>
                        <Typography>
                            Система сканирования и генерации почтовых бланков облегчит и ускорит процесс обработки
                            почты: операторы смогут легко принимать посылки, а клиенты легко оформлять отправления не
                            стоя в очереди в отделении
                        </Typography>
                    </Box>
                </Stack>
            </Sheet>
        </>
    )
}


export default App;
